/* skin magic redesign — product page: gallery, variants, one-time vs subscribe, quantity, sticky bar */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || '${{amount}}';
    function withDelimiters(n, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      var parts = (n / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* app launchers pinned to the bottom of phones (Buddify's chat bubble + tab bar) would cover the sticky bar, so it sits above them */
  function floatingEl() {
    var host = document.getElementById('buddify-smart-shopping-tab-host');
    if (!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector('[class*="launcher"]') || host.shadowRoot.querySelector('[class*="tab-bar"]');
  }
  function floatingOffset() {
    var el = floatingEl();
    if (!el) return 0;
    var r = el.getBoundingClientRect();
    if (!r.height || r.top >= window.innerHeight || r.width >= window.innerWidth * 0.9) return 0;
    return Math.max(0, Math.round(window.innerHeight - r.top + 8));
  }

  function init(root) {
    if (root.dataset.smReady) return;
    root.dataset.smReady = '1';
    var dataEl = root.querySelector('[data-sm-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var moneyFormat = root.dataset.moneyFormat;
    var addLabel = root.dataset.addLabel || 'ADD TO CART';
    var soldOutLabel = root.dataset.soldOutLabel || 'SOLD OUT';
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[data-sm-qty-input]');
    var planInput = form.querySelector('input[name="selling_plan"]');
    var addBtn = form.querySelector('[data-sm-add]');
    var addText = addBtn.querySelector('[data-sm-add-label]');
    var freqs = root.querySelector('[data-sm-freqs]');
    var current = product.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || product.variants[0];

    /* gallery */
    var items = root.querySelectorAll('[data-sm-media]');
    var thumbs = root.querySelectorAll('[data-sm-thumb]');
    function showMedia(id) {
      var found = false;
      items.forEach(function (el) { if (el.dataset.smMedia === String(id)) found = true; });
      if (!found) return;
      items.forEach(function (el) {
        el.hidden = el.dataset.smMedia !== String(id);
        var v = el.querySelector('video');
        if (v && el.hidden) v.pause();
      });
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.dataset.smThumb === String(id) ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.smThumb); }); });

    /* prices */
    function selectedPlanId() {
      var sub = root.querySelector('input[name="sm-purchase"][value="sub"]');
      if (!sub || !sub.checked) return null;
      var f = root.querySelector('input[name="sm-freq"]:checked');
      return f ? f.value : null;
    }
    function allocation(variant, planId) {
      if (!planId || !variant.selling_plan_allocations) return null;
      return variant.selling_plan_allocations.find(function (a) { return String(a.selling_plan_id) === String(planId); }) || null;
    }
    function firstPlanId() {
      var f = root.querySelector('input[name="sm-freq"]');
      return f ? f.value : null;
    }
    function render() {
      var planId = selectedPlanId();
      var alloc = allocation(current, planId);
      var unit = alloc ? alloc.price : current.price;
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      idInput.value = current.id;
      if (planInput) { planInput.value = planId || ''; planInput.disabled = !planId; }
      if (freqs) freqs.hidden = !planId;
      root.querySelectorAll('[data-sm-price]').forEach(function (el) { el.textContent = formatMoney(unit, moneyFormat); });
      root.querySelectorAll('[data-sm-compare]').forEach(function (el) {
        var cmp = current.compare_at_price && current.compare_at_price > current.price && !alloc ? current.compare_at_price : 0;
        el.textContent = cmp ? formatMoney(cmp, moneyFormat) : '';
        el.hidden = !cmp;
      });
      root.querySelectorAll('[data-sm-once-price]').forEach(function (el) { el.textContent = formatMoney(current.price, moneyFormat); });
      var subAlloc = allocation(current, planId || firstPlanId());
      root.querySelectorAll('[data-sm-sub-price]').forEach(function (el) { if (subAlloc) el.textContent = formatMoney(subAlloc.price, moneyFormat); });
      root.querySelectorAll('[data-sm-sub-compare]').forEach(function (el) { if (subAlloc) el.textContent = formatMoney(subAlloc.compare_at_price || current.price, moneyFormat); });
      if (current.available) {
        addBtn.removeAttribute('disabled');
        addText.textContent = addLabel + ' · ' + formatMoney(unit * qty, moneyFormat);
      } else {
        addBtn.setAttribute('disabled', 'disabled');
        addText.textContent = soldOutLabel;
      }
      root.querySelectorAll('[data-sm-sticky-btn]').forEach(function (b) { b.disabled = !current.available; b.textContent = current.available ? addLabel : soldOutLabel; });
    }

    /* variants */
    var optionSets = root.querySelectorAll('[data-sm-option]');
    function onOptionChange() {
      var chosen = [];
      optionSets.forEach(function (set) { var c = set.querySelector('input:checked'); chosen.push(c ? c.value : null); });
      var match = product.variants.find(function (v) { return v.options.every(function (o, i) { return chosen[i] === null || o === chosen[i]; }); });
      if (!match) return;
      current = match;
      if (current.featured_media) showMedia(current.featured_media.id);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      render();
    }
    optionSets.forEach(function (set) { set.addEventListener('change', onOptionChange); });

    /* one-time vs subscribe */
    root.querySelectorAll('input[name="sm-purchase"], input[name="sm-freq"]').forEach(function (i) { i.addEventListener('change', render); });

    /* quantity */
    root.querySelectorAll('[data-sm-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.smQty);
        qtyInput.value = Math.min(99, Math.max(1, n));
        render();
      });
    });
    qtyInput.addEventListener('change', function () {
      var n = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.min(99, Math.max(1, n));
      render();
    });

    /* sticky bar on phones: shows once the main add button scrolls away, hides over the footer */
    var sticky = root.querySelector('[data-sm-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.sm-footer, footer');
      var addVisible = true;
      var footerVisible = false;
      var watched = null;
      var lift = function () {
        var off = floatingOffset();
        sticky.style.bottom = off ? off + 'px' : '';
        sticky.classList.toggle('sm-sticky--floating', !!off);
        var el = floatingEl();
        if (el && el !== watched && 'ResizeObserver' in window) {
          watched = el;
          new ResizeObserver(function () { if (sticky.classList.contains('is-visible')) lift(); }).observe(el);
        }
      };
      var update = function () {
        var show = !addVisible && !footerVisible;
        if (show) lift();
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      new IntersectionObserver(function (entries) { addVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; update(); }).observe(addBtn);
      if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
      window.addEventListener('resize', function () { if (sticky.classList.contains('is-visible')) lift(); });
    }

    render();
  }

  function boot() { document.querySelectorAll('[data-sm-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
